module.exports = __webpack_public_path__ + "img/404bg.4e626140.jpg";